import React, { Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { createContext } from 'use-context-selector';
import { AuthState } from 'store/types/auth';
import { AUTH_TOKEN_STORAGE_KEY } from 'utils/constants';

const initialState: AuthState = {
  isAuthenticated: Boolean(localStorage.getItem(AUTH_TOKEN_STORAGE_KEY)),
  isLoading: false,
};

const AuthContext = createContext<{
  state: AuthState;
  setState: Dispatch<SetStateAction<AuthState>>;
}>({
  state: initialState,
  setState: () => null,
});

interface Props {
  children: ReactElement;
}

const AuthContextProvider = (props: Props): ReactElement => {
  const [state, setState] = useState(initialState);
  return (
    <AuthContext.Provider value={{ state, setState }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthContextProvider };
